<template>
  <div @click="click" class="column-status">
    <div class="text">
    <span
      v-if="column.title"
      class="title"
    >{{ column.title }}</span>
    <b><span
      :class="`status-label`"
      :style="`color: ${row[column.field].cor}`"
    >{{ row[column.field].descricao }}</span></b>
      </div>
  </div>
</template>
<script>

export default {
  name: 'StatusItem',
  props: ['column', 'row'],
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  display: block;
}
</style>
